// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ilCiHg90Qi0otzWT2UO3 {
	align-items: center;
	background-color: var(--white);
	border-radius: 10px;
	display: flex;
	height: 28px;
	gap: 8px;
	padding: 0 5px;
}

.fXnBcaP8Yx6pbXdTMbHf {
	align-items: center;
	background-color: var(--gray);
	border-radius: 15px;
	border: 1px solid #ebedf0;
	display: flex;
	height: 20px;
	justify-content: center;
	overflow: hidden;
	width: 20px;
}

.jocRIDgVyC8hhuMwEP9D {
	height: 20px;
	width: 20px;
}

.LroVRdCpdSVn8Jl8n6In {
	color: var(--black);
	font-size: 14px;
	letter-spacing: -0.04em;
	line-height: 20px;
	text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/components/SymbiosisInput/Account.pcss"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,8BAA8B;CAC9B,mBAAmB;CACnB,aAAa;CACb,YAAY;CACZ,QAAQ;CACR,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,6BAA6B;CAC7B,mBAAmB;CACnB,yBAAyB;CACzB,aAAa;CACb,YAAY;CACZ,uBAAuB;CACvB,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,yBAAyB;AAC1B","sourcesContent":[".container {\n\talign-items: center;\n\tbackground-color: var(--white);\n\tborder-radius: 10px;\n\tdisplay: flex;\n\theight: 28px;\n\tgap: 8px;\n\tpadding: 0 5px;\n}\n\n.iconContainer {\n\talign-items: center;\n\tbackground-color: var(--gray);\n\tborder-radius: 15px;\n\tborder: 1px solid #ebedf0;\n\tdisplay: flex;\n\theight: 20px;\n\tjustify-content: center;\n\toverflow: hidden;\n\twidth: 20px;\n}\n\n.icon {\n\theight: 20px;\n\twidth: 20px;\n}\n\n.address {\n\tcolor: var(--black);\n\tfont-size: 14px;\n\tletter-spacing: -0.04em;\n\tline-height: 20px;\n\ttext-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ilCiHg90Qi0otzWT2UO3`,
	"iconContainer": `fXnBcaP8Yx6pbXdTMbHf`,
	"icon": `jocRIDgVyC8hhuMwEP9D`,
	"address": `LroVRdCpdSVn8Jl8n6In`
};
export default ___CSS_LOADER_EXPORT___;
